<!-- FooterComponent.vue -->
<template>
    <footer>
      <div class="copyright -green">
        <small><a class="nav-link" href="https://docs.google.com/forms/d/e/1FAIpQLScVHFQq541RNFLY4sPWp7SgNOIQFbVU8jcI2Comr39biBFhNw/viewform" target="_blank">©maekawa</a>
        </small>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterComponent'
  };
  </script>
  
  <style scoped>
  /* FooterComponentのCSS */
  footer {
    padding-top: 0;
  }
  </style>
  